import script from "./DriveCimAmrecPublicPage.vue?vue&type=script&setup=true&lang=js"
export * from "./DriveCimAmrecPublicPage.vue?vue&type=script&setup=true&lang=js"

import "./DriveCimAmrecPublicPage.vue?vue&type=style&index=0&id=441c5a0c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-441c5a0c"]])

export default __exports__